import { featureData } from '@/mocks/gossipData';

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            为什么选择吃瓜官网
          </h2>
          <p className="text-foreground-500 text-base max-w-lg mx-auto">
            三大核心优势，让您吃瓜快人一步
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featureData.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-8 hover:border-primary-300 transition-all duration-300 cursor-default"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-heading text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}